<div class="filter-box grid align-center">
  <div class="xs-12 m-2 title">{{'color-filter.by-colors' | i18next}}</div>
  <div class="xs-12 m-10">
    <div class="color-palette scroll-h">
      <div class="color"
           (click)="handleColorsSelected('beige')"
           [ngClass]="{'selected': colorsSelected.beige}"
      >
        <div class="color-circle beige">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.beige' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('blau')"
           [ngClass]="{'selected': colorsSelected.blau}"
      >
        <div class="color-circle blue">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.blue' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('bunt')"
           [ngClass]="{'selected': colorsSelected.bunt}"
      >
        <div class="color-circle colorful">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.colorful' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('braun')"
           [ngClass]="{'selected': colorsSelected.braun}"
      >
        <div class="color-circle brown">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.brown' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('grau')"
           [ngClass]="{'selected': colorsSelected.grau}"
      >
        <div class="color-circle grey">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.grey' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('schwarz')"
           [ngClass]="{'selected': colorsSelected.schwarz}"
      >
        <div class="color-circle black">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.black' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('rot')"
           [ngClass]="{'selected': colorsSelected.rot}"
      >
        <div class="color-circle red">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.red' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('rosa')"
           [ngClass]="{'selected': colorsSelected.rosa}"
      >
        <div class="color-circle pink">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.pink' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('lila')"
           [ngClass]="{'selected': colorsSelected.lila}"
      >
        <div class="color-circle purple">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.purple' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('türkis')"
           [ngClass]="{'selected': colorsSelected['türkis']}"
      >
        <div class="color-circle turquoise">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.turquoise' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('kupfer')"
           [ngClass]="{'selected': colorsSelected.kupfer}"
      >
        <div class="color-circle copper">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.copper' | i18next}}
      </div>

      <div class="color"
           (click)="handleColorsSelected('grün')"
           [ngClass]="{'selected': colorsSelected['grün']}"
      >
        <div class="color-circle green">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.green' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('hellgrün')"
           [ngClass]="{'selected': colorsSelected['hellgrün']}"
      >
        <div class="color-circle light-green">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.light-green' | i18next}}
      </div>


      <div class="color"
           (click)="handleColorsSelected('weiß')"
           [ngClass]="{'selected': colorsSelected['weiß']}"
      >
        <div class="color-circle white">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.white' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('gelb')"
           [ngClass]="{'selected': colorsSelected.gelb}"
      >
        <div class="color-circle yellow">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.yellow' | i18next}}
      </div>

      <div class="color"
           (click)="handleColorsSelected('orange')"
           [ngClass]="{'selected': colorsSelected.orange}"
      >
        <div class="color-circle orange">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.orange' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('taupe')"
           [ngClass]="{'selected': colorsSelected['taupe']}"
      >
        <div class="color-circle taupe">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.taupe' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('klar')"
           [ngClass]="{'selected': colorsSelected.klar}"
      >
        <div class="color-circle clear">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.clear' | i18next}}
      </div>

      <div class="color"
           (click)="handleColorsSelected('gold')"
           [ngClass]="{'selected': colorsSelected.gold}"
      >
        <div class="color-circle gold">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.gold' | i18next}}
      </div>

      <div class="color"
           (click)="handleColorsSelected('Edelstahl')"
           [ngClass]="{'selected': colorsSelected.Edelstahl}"
      >
        <div class="color-circle stainless-steel">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.stainless-steel' | i18next}}
      </div>
      <div class="color"
           (click)="handleColorsSelected('silber/platin')"
           [ngClass]="{'selected': colorsSelected['silber/platin']}"
      >
        <div class="color-circle silver-platinum">
          <img src="./assets/img/checkmark-circle.svg">
        </div>
        {{'color-filter.silver-platinum' | i18next}}
      </div>
    </div>
  </div>
</div>
